import { usePointUnbindStreamMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const usePointUnbindStream = () => {
  const [mutation, mutationResult] = usePointUnbindStreamMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (pointId: string) => {
    const result = await mutation({
      variables: { input: { pointId } },
      refetchQueries: ['point', 'pointList'],
      awaitRefetchQueries: true,
    });

    return !!result.data?.smartlkPointUnbindStream?.ok;
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default usePointUnbindStream;
